import { render } from "./Crimes.vue?vue&type=template&id=6f8bd8d0&scoped=true"
import script from "./Crimes.vue?vue&type=script&lang=js"
export * from "./Crimes.vue?vue&type=script&lang=js"

import "./Crimes.vue?vue&type=style&index=0&id=6f8bd8d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f8bd8d0"]])

export default __exports__